
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"13"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M12.633 1.473c.547.492.957 1.066 1.176 1.75a3.94 3.94 0 01.082 2.105 3.659 3.659 0 01-.985 1.805L7.63 12.602a.873.873 0 01-.629.273.792.792 0 01-.629-.273L1.094 7.16A3.692 3.692 0 01.082 5.328c-.164-.71-.11-1.394.11-2.105a3.762 3.762 0 011.175-1.75A3.504 3.504 0 013.035.68a3.807 3.807 0 011.832.136 4.25 4.25 0 011.586 1.012L7 2.375l.547-.547c.437-.465.984-.793 1.586-1.012A3.782 3.782 0 0110.965.68c.601.11 1.176.382 1.668.793z"}})])
          )
        }
      }
    